// Services
import { initializeKycMethodService } from '../services/kyc-landing.service';
// Types
import { IdentificationApiResponseType } from 'types/identification-api-response.type';
import { KycLandingApiType } from '../types/kyc-landing-api.type';

const initializeKycMethodResolver = async ({
  consents,
  method,
}: KycLandingApiType): Promise<[IdentificationApiResponseType] | [null, true]> => {
  const [response] = await initializeKycMethodService({ consents, method });

  return response?.identificationId ? [response] : [null, true];
};

export { initializeKycMethodResolver };
